/**
 * Known keyboard layouts with their code → key mappings.
 * Used for instant layout detection from just a few key presses.
 *
 * Each layout maps physical key codes (e.g., "KeyA") to the character
 * that key produces on that layout without any modifiers.
 */

// prettier-ignore
export const KNOWN_LAYOUTS: Record<string, Record<string, string>> = {
  qwerty: {
    KeyA: "a", KeyB: "b", KeyC: "c", KeyD: "d", KeyE: "e", KeyF: "f", KeyG: "g",
    KeyH: "h", KeyI: "i", KeyJ: "j", KeyK: "k", KeyL: "l", KeyM: "m", KeyN: "n",
    KeyO: "o", KeyP: "p", KeyQ: "q", KeyR: "r", KeyS: "s", KeyT: "t", KeyU: "u",
    KeyV: "v", KeyW: "w", KeyX: "x", KeyY: "y", KeyZ: "z",
  },
  dvorak: {
    KeyA: "a", KeyB: "x", KeyC: "j", KeyD: "e", KeyE: ".", KeyF: "u", KeyG: "i",
    KeyH: "d", KeyI: "c", KeyJ: "h", KeyK: "t", KeyL: "n", KeyM: "m", KeyN: "b",
    KeyO: "r", KeyP: "l", KeyQ: "'", KeyR: "p", KeyS: "o", KeyT: "y", KeyU: "g",
    KeyV: "k", KeyW: ",", KeyX: "q", KeyY: "f", KeyZ: ";",
  },
  azerty: {
    KeyA: "q", KeyB: "b", KeyC: "c", KeyD: "d", KeyE: "e", KeyF: "f", KeyG: "g",
    KeyH: "h", KeyI: "i", KeyJ: "j", KeyK: "k", KeyL: "l", KeyM: ",", KeyN: "n",
    KeyO: "o", KeyP: "p", KeyQ: "a", KeyR: "r", KeyS: "s", KeyT: "t", KeyU: "u",
    KeyV: "v", KeyW: "z", KeyX: "x", KeyY: "y", KeyZ: "w",
  },
  qwertz: {
    KeyA: "a", KeyB: "b", KeyC: "c", KeyD: "d", KeyE: "e", KeyF: "f", KeyG: "g",
    KeyH: "h", KeyI: "i", KeyJ: "j", KeyK: "k", KeyL: "l", KeyM: "m", KeyN: "n",
    KeyO: "o", KeyP: "p", KeyQ: "q", KeyR: "r", KeyS: "s", KeyT: "t", KeyU: "u",
    KeyV: "v", KeyW: "w", KeyX: "x", KeyY: "z", KeyZ: "y",
  },
  colemak: {
    KeyA: "a", KeyB: "b", KeyC: "c", KeyD: "s", KeyE: "f", KeyF: "t", KeyG: "d",
    KeyH: "h", KeyI: "u", KeyJ: "n", KeyK: "e", KeyL: "i", KeyM: "m", KeyN: "k",
    KeyO: "y", KeyP: ";", KeyQ: "q", KeyR: "p", KeyS: "r", KeyT: "g", KeyU: "l",
    KeyV: "v", KeyW: "w", KeyX: "x", KeyY: "o", KeyZ: "z",
  },
};
